function CheckFlatIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="#000"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M20.285 2L9 13.567 3.714 8.556 0 12.272 9 21 24 5.715 20.285 2z" />
    </svg>
  )
}

export default CheckFlatIcon
